import { initialState } from './constants';
export var toastServiceDataSelector = function (state) { return (state === null || state === void 0 ? void 0 : state.content.data) || []; };
export var toastServiceLastToastIdSelector = function (state) {
    return (state === null || state === void 0 ? void 0 : state.content.lastToastId) || initialState.content.lastToastId;
};
